import React, { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";
import api from "@/lib/api";

export default function TrendingSkills({ onSelect }) {
  const [skills, setSkills] = useState([]);

  useEffect(() => {
    api.get("/jobs/trending-skills?limit=12").then((r) => setSkills(r.data || [])).catch(() => {});
  }, []);

  if (skills.length === 0) return null;

  return (
    <div className="mb-6 rounded-xl border border-white/10 bg-white/[0.02] p-4" data-testid="trending-skills">
      <p className="font-mono-tech text-xs uppercase tracking-wider text-[#94A3B8] mb-3 flex items-center gap-1.5">
        <TrendingUp className="w-3.5 h-3.5 text-[#FBBF24]" /> Trending skills this month
      </p>
      <div className="flex flex-wrap gap-2">
        {skills.map((s) => (
          <button key={s.skill} onClick={() => onSelect?.(s.skill)} data-testid={`trending-skill-${s.skill.replace(/\s+/g, "-")}`}
            className="group inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full border border-white/10 bg-[#0e1424] text-[#cbd5e1] hover:border-[#00F0FF]/50 hover:text-[#00F0FF] transition capitalize">
            {s.skill}
            <span className="font-mono-tech text-[10px] text-[#64748B] group-hover:text-[#00F0FF]">{s.count}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
